import { Controller } from "@hotwired/stimulus"
import { showToast } from "../lib/toast"

// When a tool permission refuses a background request (pmfit K6-7: a tool
// set to None, or a change on one set to Read only), the server marks the
// response with X-Access-Blocked. Whatever the page's own script does with
// the failure, the person sees why — one red toast per burst. Same pattern
// as role_mask_guard_controller.
export default class extends Controller {
  connect() {
    if (window.__accessGuardInstalled) return
    window.__accessGuardInstalled = true

    const originalFetch = window.fetch.bind(window)
    window.fetch = async (...args) => {
      const resp = await originalFetch(...args)
      try {
        const marker = resp?.headers?.get("X-Access-Blocked")
        if (marker) this._toast(decodeURIComponent(marker))
      } catch {
        // Never let the guard break the caller.
      }
      return resp
    }
  }

  _toast(message) {
    const now = Date.now()
    if (now - (window.__accessGuardLastToast || 0) < 1500) return
    window.__accessGuardLastToast = now
    showToast(message, "error")
  }
}
